import { useDictionary } from '@adamlip/okeoke.client';
import { Button } from '@nextui-org/react';
import { AppParamsContext } from 'contexts/AppParamsContext';
import { UserContext } from 'contexts/UserContext';
import { useContext, useState } from 'react';
import Login from 'views/Login';
import Achievements from 'views/VipProfile/VipProfileElements/Achievements';
import CurrentCardLevel from 'views/VipProfile/VipProfileElements/CurrentCardLevel';
import ProfileData from 'views/VipProfile/VipProfileElements/ProfileData';

function VipProfile() {

  const { appParams } = useContext(AppParamsContext);

  const { isVipBrand, userLoggedIn, getVipAchievements } = useContext(UserContext);
  const { getValue } = useDictionary();
  const [loginModal, setLoginModal] = useState(false);
  if (!userLoggedIn) {
    return (
      <div className='flex flex-col gap-2 items-center justify-center h-full w-full max-w-[95%] mx-auto  relative overflow-y-scroll pb-[50%]'>
        <div className='w-full text-center text-xl font-bold'>{getValue('app_v2_youAreNotLoggedIn')}</div>
        <div className='w-full text-center mb-4'>{getValue('app_v2_youAreNotLoggedIn_desc')}</div>
        <Button color='primary' onPress={() => setLoginModal(true)}>
          {getValue('app_v2_login')}
        </Button>
        {loginModal && <Login isOpen={loginModal} setIsOpen={setLoginModal} />}
      </div>
    );
  }

  if (!isVipBrand)
    return (
      <div className='flex flex-col gap-2 items-center justify-center h-full w-full  relative overflow-y-scroll pb-[50%]'>
        <div className=''>{getValue('vip.not.available')}</div>
        <Button color='primary' onPress={() => window.location.reload()}>
          {getValue('vip.reload')}
        </Button>
      </div>
    );
  return (
    <div className={`flex flex-col grow gap-2 items-center h-full w-full pt-2 relative overflow-hidden  ${appParams?.styles?.fonts?.capitalize ? 'font-extrabold uppercase' : ''}`}>
      <div className='font-bold text-2xl'>{getValue('vipProfile.title')}</div>
      <div className='grow  w-[90%] overflow-y-auto flex flex-col gap-2'>
        <ProfileData />
        <CurrentCardLevel />
        <Achievements getVipAchievements={getVipAchievements} />
      </div>
    </div>
  );
}

export default VipProfile;
